module.exports = __webpack_public_path__ + "static/media/menu-close-icon.fc42ea00.svg";